import React from 'react'

interface ELSSHelpContentProps {
    onDismiss: () => void
}

const ELSSHelpContent: React.FC<ELSSHelpContentProps> = ({ onDismiss }) => {
    return (
        <div className="px-5 space-y-4">
            <ul className='list-disc pl-3 text-sm'>
                <li>
                    <span className="text-grey40">The rebalance recommendation is for your entire fund value, not just the unlocked units.</span>
                </li>
                <li>
                    <span className="text-grey40">You can only switch the units that have completed the 3-year lock-in period. As more units complete 3 years, switch them based on the rebalancing recommendation.</span>
                </li>
                <li>
                    <span className="text-grey40">There's currently no way to rebalance the locked units before the lock-in period ends.</span>
                </li>
            </ul>
            {/* <div className='text-blue30 text-sm bg-gradient-to-r from-[#E6F2FF] from-0% to-[rgba(230,242,255,0)] to-100% rounded-xl p-4'>
                Given ELSS funds offer no tax benefits in the new tax regime, we recommend you to switch to <strong>top-ranked Flexi Cap or Contra funds</strong> for similar returns and risk profile.
            </div> */}
        </div>
    )
}

export default ELSSHelpContent
